import { createContext, useContext, useState, useEffect } from "react";
import queryString from "query-string";
import config from "config";
import API from "utils/API";


const myprofileContextDefaultValues = {
  infos: {},
  staffData: {},
  filterData: {},
  inputs: {},
  storeStaffData: () => {},
  storeInputs: () => {},
};

const MyProfileContext = createContext(myprofileContextDefaultValues);

export function MyProfileProvider({ children }) {
  const query = queryString.parse(window.location.search);
  let userData = window.$user_profile;
  // console.log(userData);
  const [infos] = useState({
    tabActive: query?.tab === "edit" ? "editmyprofile" : "myprofile",
  });
  const [staffData, setStaffData] = useState({});
  const [filterData] = useState({
    status: "",
    data: "",
    err: 0,
    err_msg: "",
  });
  const [inputs, setInputs] = useState({});

  useEffect(() => {
    if (userData?.idu) {
      const mainFunc = async () =>
        await API.post("myprofile/detail", {
          params: ({
            id: userData.idu,
            path: window.location.pathname,
            type: "personaldata",
            staff_id: userData.idu,
          }),
        });
      mainFunc()
        .then((res) => {
          const decrypt = (res?.data);
          // console.log("myprofile detail=", decrypt);
          if (decrypt?.status === "success") {
            if (decrypt?.data?.photo) {
              const photoURL = decrypt.data.photo;
              decrypt.data.photo = [{ data_url: photoURL }];
            }
            setStaffData(decrypt);
          } else {
            setStaffData({
              err: 1,
              err_msg: decrypt?.err_msg ?? "",
            });
          }

          // console.log("user detail=>", res.data);
          // if (res.data.data?.photo) {
          //   const photoURL = res.data.data.photo;
          //   res.data.data.photo = [{ data_url: photoURL }];
          // }
          // setStaffData(res.data);
        })
        .catch((err) => {
          console.log(err);
          setStaffData({ err: 1, err_msg: `Failes : ${err}` });
        });
    }
  }, [userData?.idu]);

  const storeStaffData = (data) => {
    setStaffData(data);
  };

  const storeInputs = (data) => {
    setInputs(data);
  };

  const value = {
    infos,
    staffData: staffData,
    filterData: filterData,
    inputs: inputs,
    storeStaffData: storeStaffData,
    storeInputs: storeInputs,
  };

  return (
    <MyProfileContext.Provider value={value}>
      {children}
    </MyProfileContext.Provider>
  );
}

export const useMyProfile = () => useContext(MyProfileContext);

